var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5357 1.80739C13.7073 0.635818 15.6067 0.635818 16.7783 1.80739L18.1925 3.2216C19.3641 4.39318 19.3641 6.29267 18.1925 7.46424L7.80003 17.8568C7.66043 17.9964 7.48263 18.0915 7.28904 18.1302L1.98573 19.1909C1.28601 19.3308 0.669094 18.7139 0.809038 18.0142L1.8697 12.7109C1.90842 12.5173 2.00357 12.3395 2.14317 12.1999L12.5357 1.80739ZM15.3641 3.2216L16.7783 4.63582C17.1688 5.02634 17.1688 5.65951 16.7783 6.05003L15.3641 7.46425L12.5357 4.63582L13.9499 3.2216C14.3404 2.83108 14.9736 2.83108 15.3641 3.2216ZM11.1215 6.05003L3.77148 13.4L3.06437 16.9356L6.59991 16.2284L13.9499 8.87846L11.1215 6.05003Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.30abcf60776ad04e108dab9716286f3c.svg";
export { ForwardRef as ReactComponent };